export function getExtension (originalName: string): string {
    return originalName.split(".").pop()!;
}